import React, { useState, useEffect } from 'react';
import { getUserInfo } from '../user';
import SecuredImage from '../components/SecuredImage';

export default function UserSettingsPage() {
  const [notifications, setNotifications] = useState({
    email: true,
    sms: false,
    push: true,
  });
  const [success, setSuccess] = useState(false);
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({});
  const [photoPreview, setPhotoPreview] = useState('');
  useEffect(() => {
    getUserInfo().then((info) => {
      setUser(info);
      setForm({
        email: info?.email || '',
        name: info?.name || '',
      });
      setPhotoPreview(info?.avatar || '');
    });
  }, []);
  function getInitials(u) {
    return u?.initials || '?';
  }

  function handleChange(e) {
    const { name, checked } = e.target;
    setNotifications((n) => ({ ...n, [name]: checked }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    // Save logic here (API call)
    setSuccess(true);
    setTimeout(() => setSuccess(false), 2000);
  }

  return (
    <div className="space-y-4 lg:space-y-8 dark:text-gray-100">
      {/* Banner */}
      <div className="relative rounded-lg bg-gradient-to-r from-emerald-400 to-purple-500 p-6 text-center overflow-hidden" style={{ minHeight: '180px' }}>
        <img
          src="/profile-header.png"
          alt="Profile Banner"
          className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none select-none"
          style={{ zIndex: 0 }}
          onError={e => { e.target.style.display = 'none'; }}
        />
        <div className="relative z-10 mb-5 inline-block">
          <div className="rounded-full bg-white/50 p-2">
            {photoPreview ? (
              <SecuredImage
                src={photoPreview}
                alt="User Avatar"
                className="inline-block size-20 rounded-full"
                fallback={
                  <div className="inline-flex size-20 items-center justify-center rounded-full bg-emerald-700 text-2xl font-bold text-white">
                    {getInitials(user)}
                  </div>
                }
              />
            ) : (
              <div className="inline-flex size-20 items-center justify-center rounded-full bg-emerald-700 text-2xl font-bold text-white">
                {getInitials(user)}
              </div>
            )}
          </div>
        </div>
        <h3 className="relative z-10 text-xl font-bold text-white">{form.name || user?.email || 'User'}</h3>
        <h4 className="relative z-10 text-sm font-medium text-white/90">&nbsp;</h4>
      </div>
      {/* END Banner */}
      {/* Notifications Card */}
      <div className="flex flex-col overflow-hidden rounded-lg bg-white shadow-xs dark:bg-gray-800 dark:text-gray-100">
        <div className="grow p-5 md:flex lg:p-8">
          <div className="mb-5 border-b border-gray-200 md:mb-0 md:w-1/3 md:flex-none md:border-0 dark:border-gray-700">
            <h3 className="mb-1 flex items-center justify-start gap-2 font-semibold">
              <svg className="hi-mini hi-bell inline-block size-5 text-emerald-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 2a6 6 0 00-6 6v2.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 10.586V8a6 6 0 00-6-6zm0 16a2 2 0 002-2H8a2 2 0 002 2z" /></svg>
              <span>Notifications</span>
            </h3>
            <p className="mb-5 text-sm text-gray-500 dark:text-gray-400">Manage how you receive notifications from Agromate.</p>
          </div>
          <div className="md:w-2/3 md:pl-24">
            <form className="space-y-6 xl:w-2/3" onSubmit={handleSubmit}>
              <div className="space-y-4">
                <label className="flex items-center gap-3">
                  <input type="checkbox" name="email" checked={notifications.email} onChange={handleChange} className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500" />
                  <span>Email notifications</span>
                </label>
                <label className="flex items-center gap-3">
                  <input type="checkbox" name="sms" checked={notifications.sms} onChange={handleChange} className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500" />
                  <span>SMS notifications</span>
                </label>
                <label className="flex items-center gap-3">
                  <input type="checkbox" name="push" checked={notifications.push} onChange={handleChange} className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500" />
                  <span>Push notifications</span>
                </label>
              </div>
              <button type="submit" className="inline-flex items-center justify-center gap-2 rounded-lg border border-emerald-700 bg-emerald-700 px-3 py-2 text-sm leading-5 font-semibold text-white hover:border-emerald-600 hover:bg-emerald-600 hover:text-white focus:ring-3 focus:ring-emerald-400/50 active:border-emerald-700 active:bg-emerald-700 dark:focus:ring-emerald-400/90">Save Settings</button>
              {success && <div className="text-green-600">Settings saved!</div>}
            </form>
          </div>
        </div>
      </div>
      {/* END Notifications Card */}
    </div>
  );
}
